export default __webpack_public_path__ + "static/media/ods15.32fe345b.svg";